import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-l-angle-left",
  "use": "icon-l-angle-left-usage",
  "viewBox": "0 0 165 165",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165 165\" id=\"icon-l-angle-left\"><path transform=\"matrix(-1 0 0 -1 164.77 164.77)\" fill-rule=\"evenodd\" d=\"M100.740115 82.3847763 100.769553 82.4142136 65.4142136 117.769553 64 116.355339 97.9705627 82.3847763 64 48.4142136 65.4142136 47 100.769553 82.3553391 100.740115 82.3847763z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol